import InformativeBox from '@monofront/design-system/components/InformativeBox';
import { IPrismicImage, IPrismicRichText } from '@monofront/types';
import { RichText } from 'prismic-reactjs';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';

type InformationBlockPrismicContent = {
  primary: {
    backgroundColor: string;
    text: IPrismicRichText;
    image: IPrismicImage;
  };
};

type InformationBlockProps = {
  prismicContent: InformationBlockPrismicContent;
};

const InformationBlock: React.FC<InformationBlockProps> = ({
  prismicContent,
}) => {
  const { text, image, backgroundColor } = prismicContent.primary;

  return (
    <InformativeBox
      hasPadding={false}
      hasImageOnMobile
      backgroundColor={backgroundColor}
      icon={
        <ResponsiveImage
          src={image?.url || ''}
          alt={image?.alt}
          width={24}
          height={24}
          layout="fixed"
        />
      }
      UNSAFE_className="tw-p-4 tw-justify-center"
    >
      {text && (
        <div className="tw-lf-body-regular-md [&_p]:tw-leading-normal">
          <RichText render={text} />
        </div>
      )}
    </InformativeBox>
  );
};

export default InformationBlock;
